/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFeedMill } from '../../models/customer-feed-mill';

export interface FindByBusinessNumber$Params {
  businessNumber: string;
  zipCode: string;
}

export function findByBusinessNumber(http: HttpClient, rootUrl: string, params: FindByBusinessNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerFeedMill>>> {
  const rb = new RequestBuilder(rootUrl, findByBusinessNumber.PATH, 'get');
  if (params) {
    rb.path('businessNumber', params.businessNumber, {});
    rb.path('zipCode', params.zipCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerFeedMill>>;
    })
  );
}

findByBusinessNumber.PATH = '/api/customer/feedMill/businessNumber/{businessNumber}/zipCode/{zipCode}';
